import { render, staticRenderFns } from "./CardDevedor.vue?vue&type=template&id=01716779"
import script from "./CardDevedor.vue?vue&type=script&lang=js"
export * from "./CardDevedor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dartanghanvani/Documents/workspace/recuperi-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01716779')) {
      api.createRecord('01716779', component.options)
    } else {
      api.reload('01716779', component.options)
    }
    module.hot.accept("./CardDevedor.vue?vue&type=template&id=01716779", function () {
      api.rerender('01716779', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/CardDevedor.vue"
export default component.exports